module.exports = __webpack_public_path__ + "static/media/1.e16e3ba2.JPG";